import { Button } from "@mui/material";
import React from "react";

type Props = {
	onNewProcess: () => void;
};

const NewProcessStatusBar = ({ onNewProcess }: Props) => {
	return (
		<Button variant="contained" color="primary" onClick={onNewProcess}>
			NEW PROCESS
		</Button>
	);
};

export default NewProcessStatusBar;
